
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';
import SignIn from '@/pages/SignIn';
import SignUp from '@/pages/SignUp';
import VerifyEmail from '@/pages/VerifyEmail';
import Home from '@/pages/Home';
import Payment from '@/pages/Payment';
import History from '@/pages/History';
import BluetoothDevices from '@/pages/BluetoothDevices';
import Profile from '@/pages/Profile';
import Settings from '@/pages/Settings';
import EditProfile from '@/pages/EditProfile';
import BackOffice from '@/pages/BackOffice';
import ContactUs from '@/pages/ContactUs';
import Policy from '@/pages/Policy';
import Privacy from '@/pages/Privacy';
import NotFound from '@/pages/NotFound';
import AuthenticatedRoute from '@/components/navigation/AuthenticatedRoute';
import { AuthProvider } from '@/context/AuthProvider';
import { LanguageProvider } from '@/context/LanguageContext';
import { PaymentProvider } from '@/context/PaymentContext';
import { WebhookProvider } from '@/context/WebhookContext';
import { ChatProvider } from '@/context/ChatContext';
import PinTransfer from '@/pages/PinTransfer';
import ChatBox from '@/components/chat/ChatBox';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <div className="dark:bg-gray-950">
      <LanguageProvider>
        <AuthProvider>
          <PaymentProvider>
            <WebhookProvider>
              <ChatProvider>
                <Router>
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/signin" element={<SignIn />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/verify" element={<VerifyEmail />} />
                    
                    <Route element={<AuthenticatedRoute />}>
                      <Route path="/home" element={<Home />} />
                      <Route path="/payment" element={<Payment />} />
                      <Route path="/history" element={<History />} />
                      <Route path="/devices" element={<BluetoothDevices />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/edit-profile" element={<EditProfile />} />
                      <Route path="/backoffice" element={<BackOffice />} />
                      <Route path="/contact" element={<ContactUs />} />
                      <Route path="/pin-transfer" element={<PinTransfer />} />
                    </Route>
                    
                    <Route path="/policy" element={<Policy />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                  <ChatBox />
                </Router>
              </ChatProvider>
            </WebhookProvider>
          </PaymentProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
